import ApiDocs from '../pages/api-docs'
import AssistantIntro from '../pages/assistant-intro'
import AssistantLauncherPage from '../pages/assistant-launcher'
import AssistantLauncherDynamicPage from '../pages/assistant-launcher-dynamic'
import Career from '../pages/career'
import Careers from '../pages/careers'
import ConfirmIntegration from '../pages/confirm-integration'
import CreateCareer from '../pages/create-career'
import Register from '../pages/register'
import ReleaseNotesPage from '../pages/release-notes'
import ScrollytellingPage from '../pages/scrollytelling'
import SettingsLayout from '../pages/settings'
import { settingsRoutes } from '../pages/settings/sections'
import Support from '../pages/support'
// import Payment from '../../pages/payment'
import ConfirmEmail from '../pages/confirm-email'
import CreateTeamAnalyse from '../pages/create-team-analyse'
import Funnel from '../pages/funnel'
import IdeaPage from '../pages/idea'
import {
  InternalUpdate,
  InternalUpdatesOverview
} from '../pages/internal-updates'
import Login from '../pages/login'
import { ProductUpdate, ProductUpdatesOverview } from '../pages/product-updates'
import RecoverCareers from '../pages/recover-careers'
import RecoverTalents from '../pages/recover-talents'
import SignMeWithEmailPassword from '../pages/sign-me-with-email-password'
import Talent from '../pages/talent'
import Talents from '../pages/talents'
import TeamAnalyse from '../pages/team-analyse'
import TeamAnalyses from '../pages/team-analyses'
import TestLibrary from '../pages/test-library'
import Usage from '../pages/usage'
// import Upgrade from '../pages/upgrade'
// #import Checkout from '../pages/checkout'
// import FAQ from '../../pages/faq'

// fillViewport: die Seite füllt den Viewport und nur ihre Tabelle (Table
// fillHeight) bzw. ihr Inhaltsbereich scrollt, siehe Layout
// children: Kindrouten, die Component per <Outlet /> rendert
export const routes = [
  { path: '/careers', Component: Careers, useLayout: true, fillViewport: true },
  { path: '/career/:id', Component: Career, useLayout: true },
  { path: '/career/new', Component: CreateCareer, useLayout: true },
  { path: '/career/new/:id', Component: CreateCareer, useLayout: true },
  { path: '/talents', Component: Talents, useLayout: true, fillViewport: true },
  { path: '/talent/:id', Component: Talent, useLayout: true },
  { path: '/team-analyses', Component: TeamAnalyses, useLayout: true },
  { path: '/usage', Component: Usage, useLayout: true },
  {
    path: '/team-analyse/new',
    Component: CreateTeamAnalyse,
    useLayout: true
  },
  {
    path: '/team-analyse/new/:id',
    Component: CreateTeamAnalyse,
    useLayout: true
  },
  { path: '/team-analyse/:id', Component: TeamAnalyse, useLayout: true },
  // { path: '/payment', Component: Payment, useLayout: true },
  {
    path: '/settings',
    Component: SettingsLayout,
    useLayout: true,
    fillViewport: true,
    children: settingsRoutes
  },
  { path: '/support', Component: Support, useLayout: true },
  { path: '/release-notes', Component: ReleaseNotesPage, useLayout: true },
  {
    path: '/recover/talents',
    Component: RecoverTalents,
    useLayout: true,
    fillViewport: true
  },
  {
    path: '/recover/careers',
    Component: RecoverCareers,
    useLayout: true,
    fillViewport: true
  },
  { path: '/test-library', Component: TestLibrary, useLayout: true },
  // Interne Showcase-Seite, nicht in der Sidebar verlinkt
  { path: '/assistant-intro', Component: AssistantIntro, useLayout: true },
  {
    path: '/assistant-launcher',
    Component: AssistantLauncherPage,
    useLayout: true
  },
  {
    path: '/assistant-launcher-dynamic',
    Component: AssistantLauncherDynamicPage,
    useLayout: true
  },
  { path: '/scrollytelling', Component: ScrollytellingPage, useLayout: true },
  // Interne Updates fuer Aivy-Admins, ohne Dashboard-Layout wie die
  // oeffentlichen Produkt-Updates
  {
    path: '/internal/updates',
    Component: InternalUpdatesOverview,
    useLayout: false
  },
  {
    path: '/internal/updates/:slug',
    Component: InternalUpdate,
    useLayout: false
  },
  // Alias fuer den Tippfehler-Link
  {
    path: '/assistant-launcher-dynmaic',
    Component: AssistantLauncherDynamicPage,
    useLayout: true
  },
  {
    path: '/confirm/integration',
    Component: ConfirmIntegration,
    useLayout: false
  },
  {
    path: '/confirm-email',
    Component: ConfirmEmail,
    useLayout: true
  }
  // { path: '/upgrade', Component: Upgrade, useLayout: true },
  // { path: '/checkout', Component: Checkout, useLayout: false },
]

export const publicRoutes = [
  { path: '/funnel', Component: Funnel },
  // Oeffentliche API-Doku fuer Partner und Kunden — ohne Login erreichbar.
  { path: '/api-docs', Component: ApiDocs },
  // Oeffentliche Produkt-Updates, teilbar per Link in Newsletter und Mails.
  { path: '/product/updates', Component: ProductUpdatesOverview },
  { path: '/product/updates/:slug', Component: ProductUpdate },
  // Ideen, die wir vor dem Bau mit Kunden teilen (src/ideas).
  { path: '/ideas/:slug', Component: IdeaPage }
]

export const unauthenticatedRoutes = [
  { path: '/login', Component: Login },
  { path: '/register', Component: Register },
  { path: '/signmewithemailpassword', Component: SignMeWithEmailPassword },
  { path: '*', Component: Login }
]
